// removed by extract-text-webpack-plugin
module.exports = {"theme":"#AB0101","themeBg":"#FDF9F5","textColor":"#DB3213","subTextColor":"#999","activeColor":"#fff"};


//////////////////
// WEBPACK FOOTER
// ./src/style/index.scss
// module id = +qiL
// module chunks = 18